<template>
  <div id="newsletter-container" style="background-color: #e6e6e6;">
    <!-- Begin Constant Contact Inline Form Code -->
    <div class="ctct-inline-form" data-form-id="a09d72e9-e643-4fc7-b7a8-4eaaffa7608d" style="max-width:600px;margin:0 auto;"></div>
    <!-- End Constant Contact Inline Form Code -->
  </div>
</template>

<script>
  export default {
    name: 'NewsLetter',
  }
</script>
